module.exports = __webpack_public_path__ + "hubspot-1-6a33ebc1908bfe5a42ab70f70d75da22.webp";